import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing, colors }: Theme) => createStyles({
  descriptionBox: {
    display: 'flex',
    color: `${colors.inputs.footNote.text} !important`,
    backgroundColor: colors.inputs.footNote.background,
    marginTop: spacing(1),
    padding: `${spacing(0.5)}px ${spacing(1)}px`,

    '& path': {
      fill: colors.inputs.footNote.icon,
    },
  },
  icon: {
    marginRight: spacing(0.5),
  },
});

export default styles;
